module.exports = new __parcel__URL__("Golden-Gate-Bridge-San-Francisco.e4f43801.png").toString();